/**
 * Parse Search Form Data
 * @param  {obj} $form the form element to retrieve data from
 * @return {obj}       parsed form data
 */
export default function parseSearchFormData($form) {
  const formData = $form.serializeArray();
  const data = { post_types: [] };

  formData.forEach((i) => {
    if ('post_types[]' === i.name) {
      data.post_types.push(i.value);
    } else {
      data[i.name] = i.value;
    }
  });

  return data;
}
